import AlertComponentProps from '../../../utils/types/props/IAlertComponentProps';
import IAlertType from '../../../utils/types/props/IAlertType';

type AlertIcons = Record<IAlertType, React.ReactNode>;

const AlertComponent = ({ alerts, onDismiss }: AlertComponentProps) => {
    const icons: AlertIcons = {
        danger: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                <path d="M12 8v4"></path>
                <path d="M12 16h.01"></path>
            </svg>
        ),
        warning: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M12 9v4"></path>
                <path d="M10.363 3.591l-8.106 13.534a1.914 1.914 0 0 0 1.636 2.871h16.214a1.914 1.914 0 0 0 1.636 -2.87l-8.106 -13.536a1.914 1.914 0 0 0 -3.274 0z"></path>
                <path d="M12 16h.01"></path>
            </svg>
        ),
        success: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M5 12l5 5l10 -10"></path>
            </svg>
        ),
        info: (
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0"></path>
                <path d="M12 9h.01"></path>
                <path d="M11 12h1v4h1"></path>
            </svg>
        ),
    };

    const getIcon = (type: IAlertType): React.ReactNode => {
        return icons[type] || null;
    };

    if (!alerts.length) return null;

    return (
        <>
            {alerts.map((alert, index) => (
                <div
                    key={index}
                    className={`alert alert-${alert.type} alert-dismissible`}
                    role="alert"
                    style={{
                        whiteSpace: 'normal',
                        wordWrap: 'break-word',
                        overflowWrap: 'anywhere',
                        maxWidth: '100%',
                    }}
                >
                    <div className="alert-icon">{getIcon(alert.type)}</div>
                    {alert.message}
                    <button type="button" className="btn-close" onClick={() => onDismiss(index)} aria-label="Close"></button>
                </div>
            ))}
        </>
    );
};

export default AlertComponent;
